module.exports = __webpack_public_path__ + "img/fukuoka2.2206766e.jpg";